function isSponsorshipAvailable(profile) {
  const { sponsorship = {} } = profile
  const { type = 'None' } = sponsorship
  return type !== 'None'
}

function isSponsorshipTaskInactiveWithPOCode(tasks = []) {
  return tasks.some(
    ({ slug, isActive, assignPOCode = {} }) =>
      slug === 'sponsorship-requested' && !isActive && assignPOCode.code
  )
}

export default function calculateBasketBreakdown(
  items,
  convertPrice,
  localeICU,
  role = ''
) {
  const fixDiscount = 0
  const totalPrice = items
    .map((item) => {
      let price = 0
      const isSpon = isSponsorshipAvailable(item.bookingData.campaign.profile)
      const dynamicPricingDetails = item.bookingData.campaign.dynamicPricingDetails
      if(isSpon) {
        price = 0
      } else if (dynamicPricingDetails) {
        price = dynamicPricingDetails.grandTotal || 0
      } else {
        price = 0
      }
      return convertPrice(
        price,
        localeICU,
        item.bookingData.campaign.baseCurrency
      )
    })
    .reduce((acc, cur) => acc + cur, 0)
  const pricrBreakdown = [
    {
      name: 'Total price',
      price: totalPrice,
      type: 'heading',
      style: role === 'brand' ? 'last' : null,
    },
  ]
  // TODO: prepare for A&P wallet
  // pricrBreakdown.push({
  //   name: '- Diageo Rewards Saving',
  //   price: fixDiscount,
  //   type: 'subhead',
  //   style: 'last'
  // })
  let subTotal = items
    .map((item) => {
      const isSpon = isSponsorshipAvailable(item.bookingData.campaign.profile)
      const isSponTaskInactive = isSponsorshipTaskInactiveWithPOCode(item.bookingData.campaign.profile.tasks)
      const isForward = item.forwardUserId
      const isBudgetCode = item.budgetCode
      const dynamicPricingDetails = item.bookingData.campaign.dynamicPricingDetails
      let price = 0
      if (isSpon || isSponTaskInactive || isForward || isBudgetCode) {
        price = 0
      } else if (dynamicPricingDetails) {
        price = dynamicPricingDetails.grandTotal || 0
      } else {
        price = 0
      }
      return convertPrice(
        price,
        localeICU,
        item.bookingData.campaign.baseCurrency
      )
    })
    .reduce((acc, cur) => acc + cur, 0)
  subTotal = subTotal + fixDiscount

  pricrBreakdown.push({
    name: 'Remainder to Pay ',
    price: subTotal,
    type: 'heading',
  })

  return pricrBreakdown
}
